import { CellContext } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { GetFolderPermissionsEwsPermissionInfo } from '../../../../api/types.gen';
import { ReadPermissionLevel } from './PermissionEnums';

interface ReadPermissionCellProps {
  cellContext: CellContext<GetFolderPermissionsEwsPermissionInfo | null, ReadPermissionLevel>;
}

export function ReadPermissionCell({ cellContext }: ReadPermissionCellProps) {
  const { t } = useTranslation('', { keyPrefix: 'permissions' });
  const value = cellContext.getValue();

  switch (value) {
    case ReadPermissionLevel.FullDetails:
      return <>{t('readPermissionsFull')}</>;
    default:
      return <>{t('readPermissionsNone')}</>;
  }
}
